const CharacterPxWidth = 7;

export const DesktopNumbersOfLines = 2;
export const MobileNumbersOfLines = 3;

const getMaxAllowedCharacters = (
    ref: React.MutableRefObject<HTMLDivElement | null>,
    isMobile: boolean,
) => {
    const wrapperRect = ref?.current?.getBoundingClientRect();

    const estimatedCharPerLines = wrapperRect?.width
        ? wrapperRect.width / CharacterPxWidth
        : 100;
    const numberOfLines = isMobile
        ? MobileNumbersOfLines
        : DesktopNumbersOfLines;
    const maxAllowedCharacters = Math.floor(
        estimatedCharPerLines * numberOfLines,
    );

    return maxAllowedCharacters;
};

export default getMaxAllowedCharacters;
